namespace Ir.Components.Workbook.Settings.Items.LegendPositionSetting {
    export interface ILegendPositionSettingParams {
        legendPosition: KnockoutObservable<LegendPositionEnum>;
    }
    interface IViewModel {
        dxSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
    }

    interface IParams {
        config: ILegendPositionSettingParams;
        
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;

        let legendPositions = [
            { text: "None", value: LegendPositionEnum.None, icon: "horizontal_rule" },
            { text: "Top", value: LegendPositionEnum.Top, icon: "align_vertical_top" },
            { text: "Bottom", value: LegendPositionEnum.Bottom, icon: "align_vertical_bottom" },
            { text: "Left", value: LegendPositionEnum.Left, icon: "align_horizontal_left" },
            { text: "Right", value: LegendPositionEnum.Right, icon: "align_horizontal_right" },
        ];

        self.dxSelectBoxConfig = {
            displayExpr: 'text',
            valueExpr: 'value',
            value: params.config.legendPosition,
            items: legendPositions,
            width: 140,
            itemTemplate(data) {
                return `<div class='custom-item-legend'><span class="material-icons">${data.icon}</span>${data.text}</div>`;
            },
            fieldTemplate(data, container) {
                const result = $(`<div class='custom-item-legend'><span class="material-icons sb">${data.icon}</span> <div class="tb"></div> </div>`);
                result
                    .find('.tb')
                    .dxTextBox({
                        value: data && data.text,
                        readOnly: true,
                    });
                container.append(result);
            }
        };
    }
}